import styled, { css } from 'styled-components'

interface EditableTextStyledProps {
  $alwaysEditable?: boolean
  $hasError?: boolean
}

export const ErrorMessage = styled.span`
  position: absolute;
  bottom: -22px;
  left: 0;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.input.error.borderColor};
`

interface ClickableLabelProps {
  $isEditable?: boolean
}

export const ClickableLabel = styled.span<ClickableLabelProps>`
  font-size: 1rem;
  font-weight: 600;
  color: black;
  cursor: ${({ $isEditable }) => ($isEditable ? 'pointer' : 'default')};
  padding: 0.2rem;

  &:hover {
    ${({ $isEditable, theme }) =>
      $isEditable &&
      css`
        color: ${theme.color.primary};
      `}
  }
`

export const EditableTextStyled = styled.div<EditableTextStyledProps>`
  position: relative;
  display: flex;
  flex-direction: ${({ $alwaysEditable }) =>
    $alwaysEditable ? 'column' : 'row'};
  align-items: ${({ $alwaysEditable }) =>
    $alwaysEditable ? 'flex-start' : 'center'};
  gap: ${({ $alwaysEditable }) => ($alwaysEditable ? '4px' : '0')};

  .input-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: ${({ theme }) => theme.input.default.color};
    letter-spacing: 0.5px;

    .required-star {
      color: ${({ theme }) => theme.color.error};
      margin-left: 2px;
    }
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  input {
    margin-right: 10px;
    font-family: ${({ theme }) => theme.font.family};
    width: 0;
    min-width: 50px;
    max-width: 600px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: black;
    font-size: 0.9rem;
    padding: 0.2rem;

    ${({ $alwaysEditable, $hasError, theme }) =>
      $alwaysEditable &&
      css`
        min-width: 280px;
        border: 1px solid
          ${$hasError
            ? theme.input.error.borderColor
            : theme.input.default.borderColor};
        border-radius: 4px;
        padding: 0.5rem 0.75rem;
        font-size: 0.95rem;
        font-weight: 500;
        height: 38px;

        &:focus {
          outline: none;
          border-color: ${$hasError
            ? theme.input.error.borderColor
            : theme.color.primary};
        }

        &::placeholder {
          color: ${$hasError
            ? theme.input.error.borderColor
            : theme.input.default.placeholder};
          font-weight: 400;
        }
      `}

    &[disabled] {
      font-size: 1rem;
      background-color: transparent;
      border: 0;
      font-weight: 600;
      height: 24px;
      padding: 0;
    }
  }
`
